var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.productContractsCount)?[_c('p',[_vm._v(_vm._s(_vm.$t("productDetails.noProductContactsYet")))])]:[(_vm.client)?_c('material-product-details-card',{attrs:{"client":_vm.client}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }